import { z } from "zod"
import { Workflow } from "../../../models/Workflow"
import * as _ from 'lodash'

export type MultiSelectSampleIdsItem = {
    value: number | string
    label: number | string
  }

export const formatMultiSelectSampleIds = (data: MultiSelectSampleIdsItem[]) => {
  return data?.map((item) => item.value)?.join(',')
}

export const formatWorkflowPayloadData = (data: Workflow) => {
  const formattedData = {
    ...data,
    patientId: data.patientId,
    workFlowId: data.workflowName,
    draftSamples:  data.id && data.draftSamples ? data.draftSamples + ',' + formatMultiSelectSampleIds(data.sampleIDs ?? []) :formatMultiSelectSampleIds(data.sampleIDs ?? []),
    samples: data.samples ?? ""
  }
  formattedData.draftSamples = _.compact(_.split(formattedData.draftSamples, ',')).join(',')
  return {
    ...formattedData
  }
}

const MultiSelectObjectSchema = z.object({
    label: z.string().or(z.number()),
    value: z.string().or(z.number()),
  })

export const getTranslatedStr = (path: string): string => {
    const translatn = 'workflowContainer.errors'
    return `${translatn}.${path}`
  }

export const workflowSchemaHelpers = {
    nullableStr:z.coerce.string().nullable(),
    nullableNumber: z.coerce.number().nullable(),
    requiredSelect: z.coerce.string().min(1, { message: getTranslatedStr('required') }),
    requiredMultiselect: z
        .string()
        .array()
        .nonempty({ message: getTranslatedStr('required') }),
    multiselect: z.array(MultiSelectObjectSchema).optional(),
}